<template>
  <div
    id="chat"
    class="bg-white px-3"
    style="margin: -20px; margin-top: -1rem; margin-bottom: 0 !important"
  >
    <div class="mb-2 mt-2 pt-3 sertop">
      <div class="sertop-right">
        <el-form inline ref="form" :model="from" label-width="100px">
          <el-form-item label="" size="small" class="mb-0 flex">
            <span class="flex-title">用户搜索：</span>
            <el-select
              v-model="from.check_type"
              placeholder="请选择"
              size="small"
              class="select"
              @change="checktype()"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select
              v-if="from.check_type == 2"
              v-model="from.channel"
              placeholder="请选择渠道"
              size="small"
              class="selecttwo"
            >
              <el-option
                v-for="item in $store.state.user.userchannel"
                :key="item.channel"
                :label="item.channel_name"
                :value="item.channel"
              >
              </el-option>
            </el-select>
            <el-input
              size="small"
              class="inpustpm"
              v-model="inputdata"
              clearable
              :disabled="
                (from.check_type == 2 && from.channel != '') ||
                from.check_type == 1
                  ? false
                  : true
              "
              :placeholder="
                from.check_type == '1' ? '请输入用户FID' : '请输入用户手机号'
              "
            ></el-input>
          </el-form-item>

          <el-form-item class="mb-0">
            <el-button type="info" @click="getok()" size="small"
              >搜索
            </el-button>
            <el-button size="small" @click="clearSearch"
              >清空筛选条件</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="user" v-if="user">
      <el-descriptions title="用户信息" border>
        <el-descriptions-item label="头像">
          <el-avatar :src="user.headurl"></el-avatar>
        </el-descriptions-item>
        <el-descriptions-item label="用户名">{{
          user.nickname
        }}</el-descriptions-item>
        <el-descriptions-item label="FID">{{ user.fid }}</el-descriptions-item>
        <el-descriptions-item label="UID">{{ user.uid }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{
          user.phonenum
        }}</el-descriptions-item>
        <el-descriptions-item label="端">{{
          siteid(user.siteid)
        }}</el-descriptions-item>
        <el-descriptions-item label="注册时间">{{
          new Date(parseInt(user.regtime) * 1000)
            .toLocaleString()
            .replace(/:\d{1,2}$/, " ")
        }}</el-descriptions-item>
        <el-descriptions-item label="积分">
          {{ user.score }}
        </el-descriptions-item>
        <el-descriptions-item label="等级">
          {{ user.level }}
        </el-descriptions-item>
        <el-descriptions-item label="注册IP">
          {{ user.ip }}
        </el-descriptions-item>
        <el-descriptions-item label="登录IP">
          {{ user.ip }}
        </el-descriptions-item>
        <el-descriptions-item label="设备信息"> 暂无 </el-descriptions-item>
        <el-descriptions-item label="修改密码">
          <el-tag size="small" @click="addpass('im')">修改IM密码</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="修改密码">
          <el-tag size="small" @click="addpass('pc')">修改PC密码</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="">
        </el-descriptions-item>
        <!-- <el-descriptions-item v-if="tabs" label="聊天记录">
          <el-tag size="small" @click="lookrecord(false)">聊天记录查询</el-tag>
        </el-descriptions-item> -->
        <!-- <el-descriptions-item v-else label="登录时间">
          <el-tag size="small" @click="lookrecord(true)">查看登录时间</el-tag>
        </el-descriptions-item> -->
      </el-descriptions>
    </div>

    <!-- 表格 -->
    <div v-if="!tabs">
      <div class="mt-3 pt-2">
        <el-table
          :data="tableData"
          @sort-change="sortChange"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            fixed
            align="center"
            type="index"
            label="排序"
            width="50"
          />
          <el-table-column align="center" prop="nickname" label="对方昵称" />
          <el-table-column align="center" prop="ptime" label="聊天创建时间" />
          <el-table-column align="center" label="操作">
            <template slot-scope="v">
              <el-button plain @click="looklist(v.row)">查看记录</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div style="height: 60px"></div>
      <el-footer
        class="d-flex border-top bg-white align-items-center px-0 position-fixed"
        style="bottom: 0; left: 200px; right: 0; z-index: 100"
      >
        <!-- 底部 -->

        <div style="flex: 1" class="px-2">
          <el-pagination
            :current-page="pagedata.current"
            :page-sizes="pagedata.sizes"
            :page-size="pagedata.size"
            @size-change="handleSizeChangedata"
            @current-change="handleCurrentChangedata"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagedata.total"
          >
          </el-pagination>
        </div>
      </el-footer>
    </div>
    <div v-else>
      <div class="mt-3 pt-2">
        <el-table
          :data="tableData"
          @sort-change="sortChange"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            fixed
            align="center"
            type="index"
            label="排序"
            width="50"
          />
          <el-table-column align="center" prop="logintime" label="登录时间" />
          <el-table-column align="center" prop="logouttime" label="登出时间" />
          <el-table-column align="center" prop="onlinetime" label="时长" />
        </el-table>
      </div>
      <div style="height: 60px"></div>
    </div>

    <el-dialog width="80%" title="消息详情" :visible.sync="chstshow">
      <div class="mt-3 pt-2">
        <el-table
          :data="tableDatatwo"
          @sort-change="sortChangetwo"
          border
          v-loading="loadingtwo"
          style="width: 100%"
          max-height="450"
        >
          <el-table-column
            fixed
            align="center"
            label="编号"
            width="50"
            prop="chatmsgno"
          >
          </el-table-column>
          <el-table-column align="center" prop="nickname" label="发送人" />
          <el-table-column align="center" prop="content" label="内容">
            <template slot-scope="v">
              <span v-if="v.row.msgtype == 1">{{ v.row.content }}</span>
              <img
                v-else-if="v.row.msgtype == 4 && v.row.img"
                :src="v.row.img.url"
                style="width: 100%"
                alt=""
              />
            </template>
          </el-table-column>
          <el-table-column align="center" prop="msgtime" label="时间" />
        </el-table>
      </div>

      <div style="height: 60px"></div>
      <el-footer>
        <div style="flex: 1" class="px-2">
          <el-pagination
            :total="pagetwo.total"
            :current-page="pagetwo.current"
            :page-sizes="pagetwo.sizes"
            :page-size="pagetwo.size"
            @size-change="handleSizeChangetwo"
            @current-change="handleCurrentChangetwo"
            layout="total, sizes, prev, pager, next, jumper"
          >
          </el-pagination>
        </div>
      </el-footer>
    </el-dialog>
  </div>
</template>

<script>
import common from "@/common/mixins/common.js";
export default {
  inject: ["layout"],
  mixins: [common],
  data() {
    return {
      editIndex: -1,
      //搜索数据
      from: {
        check_type: "1",
        fid: "",
        phone: "",
        channel: "", // 渠道号
      },
      inputdata: "",
      model_title: "Host",
      auth_val: "Mtlog",
      preUrl: "data/userinfoList", //列表地址

      tableData: [],
      tableDatatwo: [],
      loadingtwo: false,
      pagetwo: {
        current: 1,
        sizes: [10, 20, 50, 100],
        size: 10,
        total: 0,
      },
      pagedata: {
        current: 1,
        sizes: [10, 20, 50, 100],
        size: 10,
        total: 0,
      },
      proptwo: "",
      sorttwo: "descending",
      form: {
        id: 0,
        remark: "",
      },
      prop: "",
      sort: "descending",
      rule_list: [],
      check_img_list: [],
      cz_money: 0,
      tx_money: 0,
      chstshow: false,
      user: {},
      options: [
        {
          value: "1",
          label: "FID",
        },
        {
          value: "2",
          label: "手机号",
        },
      ],
      channel: [],
      tabs: true,
      chatkeydata: {}, // 聊天key
    };
  },
  watch: {},
  created() {},
  methods: {
    sortChange(column) {
      this.prop = column.prop;
      this.sort = column.order;
      this.getList();
    },
    sortChangetwo(column) {
      this.proptwo = column.prop;
      this.sorttwo = column.order;
      this.lisktget();
    },
    siteid(val) {
      if (val == 1) {
        return "安卓";
      } else if (val == 2) {
        return "IOS";
      } else if (val == 3) {
        return "H5";
      } else if (val == 4) {
        return "PC";
      } else {
        return "未知";
      }
    },
    //提交
    submit() {
      this.$refs.form.validate((res) => {
        if (res) {
          //this.form.default = this.form.default.replace(/\n/g,',')
          this.form.id = this.editIndex;
          this.addOrEdit(this.form);
          // 关闭模态框
        }
      });
    },
    // 查看消息详情
    looklist(data) {
      if (data.chatkey) {
        this.chatkeydata = data;
        this.loadingtwo = true;
        this.chstshow = true;
        this.lisktget();
      }
    },
    handleSizeChangedata(val) {
      this.pagedata.size = val;
      this.cumlist();
    },
    handleCurrentChangedata(val) {
      this.pagedata.current = val;
      this.cumlist();
    },
    handleSizeChangetwo(val) {
      this.pagetwo.size = val;
      this.lisktget();
    },
    handleCurrentChangetwo(val) {
      this.pagetwo.current = val;
      this.lisktget();
    },
    checktype() {
      this.inputdata = "";
      if (this.from.check_type == "1") {
        this.from.channel = "";
        this.from.phone = "";
        this.from.fid = this.inputdata;
      } else if (this.from.check_type == "2") {
        this.from.fid = "";
        this.from.channel = "";
        this.from.phone = this.inputdata;
      }
    },
    getok() {
      if (this.from.check_type == "1") {
        this.from.fid = this.inputdata;
        this.from.channel = "";
      } else if (this.from.check_type == "2") {
        this.from.phone = this.inputdata;
      }
      this.searchEvent();
    },
    addpass(val) {
      this.$prompt(val == "im" ? "修改IM密码" : "修改PC密码", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          let url = "";
          if (val == "im") {
            url = "data/editIMPass";
          } else if (val == "pc") {
            url = "data/editPcPass";
          }
          if (value && url) {
            this.api
              .post("/" + url, {
                uid: this.user.uid,
                id: this.user.thirduid,
                password: value,
              })
              .then((res) => {
                if (res.data.code == 1) {
                  this.$message({
                    type: "success",
                    message: "修改成功！",
                  });
                }
              })
              .catch((err) => {});
          } else {
            this.$message({
              type: "info",
              message: "密码不能为空",
            });
          }
        })
        .catch(() => {});
    },
    lookrecord(val) {
      this.tabs = val;
      if (!this.tabs) {
        // 查看聊天
        this.cumlist();
      } else {
        // 查看登录时间
        this.getok();
      }
    },
    // 查看聊天列表
    cumlist() {
      this.api
        .post("/data/userchatList", {
          search: {
            uid: this.user.uid,
          },
          page: this.pagedata.current,
          limit: this.pagedata.size,
        })
        .then((res) => {
          if (res.data.code == 1) {
            const data = res.data.data.list.data.chatlist;
            this.userlist = [];
            for (let i in data) {
              if (data[i].ptime) {
                // 时间戳转换
                data[i].ptime = new Date(parseInt(data[i].ptime) * 1000)
                  .toLocaleString()
                  .replace(/:\d{1,2}$/, " ");
              }
            }
            this.tableData = data;
            this.pagedata.total = res.data.data.list.total;
            // console.log(data);
          }
        })
        .catch((err) => {});
    },
    lisktget() {
      this.api
        .post("/data/chatDetail", {
          chatkey: this.chatkeydata.chatkey,
          page: this.pagetwo.current,
          limit: this.pagetwo.size,
          prop: this.proptwo,
          sort: this.sorttwo == "ascending" ? "asc" : "desc",
        })
        .then((res) => {
          this.tableDatatwo = [];
          let dataall = res.data.data.list.data.msgList;
          for (let i in dataall) {
            // 类型为文字和图片的显示，其他不要
            if (dataall[i].msgtype == 1 || dataall[i].msgtype == 4) {
              this.tableDatatwo.push(dataall[i]);
            }
          }
          // console.log(this.tableDatatwo, "----");
          this.pagetwo.total = res.data.data.list.total;
          this.loadingtwo = false;

          for (let i in this.tableDatatwo) {
            // 时间戳转化为日期
            this.tableDatatwo[i].msgtime = new Date(
              parseInt(this.tableDatatwo[i].msgtime) * 1000
            )
              .toLocaleString()
              .substr(0, 17);

            if (this.tableDatatwo[i].uid == this.user.uid) {
              // 如果是主播，就返回当前主播名称
              this.tableDatatwo[i].nickname = this.user.nickname;
            } else {
              // 如果是用户，就返回用户名称
              this.tableDatatwo[i].nickname = this.chatkeydata.nickname;
            }
            if (this.tableDatatwo[i].msgtype == 4) {
              this.tableDatatwo[i].img = JSON.parse(
                this.tableDatatwo[i].content
              );
            }
            // console.log(this.chatkeydata, "聊天内容");
            // console.log(this.tableDatatwo, "所有数据");
          }
        })
        .catch((err) => {
          this.loadingtwo = false;
        });
    },
    getListResult(e) {
      // 查看登录时间
      const data = e.loginrec;
      for (let i in data) {
        // 时间戳转换
        data[i].logintime = new Date(parseInt(data[i].logintime) * 1000)
          .toLocaleString()
          .replace(/:\d{1,2}$/, " ");
        data[i].logouttime = new Date(parseInt(data[i].logouttime) * 1000)
          .toLocaleString()
          .replace(/:\d{1,2}$/, " ");
        data[i].onlinetime = this.onlinetime(data[i].onlinetime);
      }
      //   用户登录时间
      this.tableData = data;
      this.user = e.user;
      console.log(this.user);
    },
    onlinetime(val) {
      if (val >= 60) {
        let mm = parseInt(val / 60);
        if (mm >= 60) {
          let hh = mm / 60;
          if (hh >= 24) {
            let dd = hh / 24;
            return dd.toFixed(2) + " 天";
          } else {
            return hh.toFixed(2) + " 小时";
          }
        } else {
          return mm + " 分钟";
        }
      } else {
        return val + " 秒";
      }
    },
    // 清空筛选条件
    clearSearch() {
      this.from = {
        check_type: "1",
        fid: "",
        phone: "",
        channel: "", // 渠道号
      };
      this.pagetwo = {
        current: 1,
        sizes: [10, 20, 50, 100],
        size: 10,
        total: 0,
      };
      this.pagedata = {
        current: 1,
        sizes: [10, 20, 50, 100],
        size: 10,
        total: 0,
      };
      this.inputdata = "";
      this.user = {};
      this.tabs = true;
      this.getok();
    },
  },
};
</script>

<style lang="scss" scoped>
.sertop {
  display: flex;
  align-items: center;
  padding-top: 20px;
  justify-content: space-between;
  .sertop-left {
    display: flex;
    align-items: center;
    span {
      font-size: 14px;
    }
  }
  .sertop-right {
    .el-form {
      display: flex;
      align-items: center;
    }
  }
}
.sertop-right {
  flex: 1;
}
::v-deep .el-form-item__content {
  display: flex;
  align-items: center;
  justify-content: center;
}
.flex-title {
  display: inline-block;
  width: 150px;
}
.el-form {
  .flex {
    // flex: 1;
  }
}
.select ::v-deep input {
  width: 100px;
}
.inpustpm {
  max-width: 300px;
}
.selecttwo ::v-deep input {
  width: 120px;
}
.user {
  margin-top: 40px;
}
.el-tag {
  cursor: pointer;
}
</style>
